export function mergeUniqueFiles(prev, next) {
  const map = new Map();
  [...prev, ...next].forEach((f) => map.set(`${f.name}__${f.size}`, f));
  return Array.from(map.values());
}

export function getBaseName(name) {
  const n = name || '';
  const i = n.lastIndexOf('.');
  return i > 0 ? n.slice(0, i) : n;
}

export function sortFilesByBaseName(files) {
  const arr = [...files];
  arr.sort((a, b) => {
    const baseA = getBaseName(a.name).toLowerCase();
    const baseB = getBaseName(b.name).toLowerCase();
    return baseA.localeCompare(baseB, undefined, { numeric: true, sensitivity: 'base' });
  });
  return arr;
}

export function filterByExt(files, validExt) {
  return files.filter((f) => {
    const name = (f.name || '').toLowerCase();
    return validExt.some((ext) => name.endsWith(ext));
  });
}